import React from 'react';
import { AccountReturnParams } from '../pages/AccountPage';
import { Accordion } from 'telia-front-react';
import EmailAccordionItem from './EmailAccordionItem';
import PasskeyAccordionItem from './PasskeyAccordionItem';
import AddEmailModal from './AddEmailModal';
import ChangePasswordModal from '../email/ChangePasswordModal';
import MergeLoginModal from './MergeLoginModal';
import EmailMergeConfirmModal from './EmailMergeConfirmModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import useStores from '../stores/UseStores';

interface IAccountLoginMethodsProps {
  returnParams: AccountReturnParams;
}

const AccountLoginMethods = (props: IAccountLoginMethodsProps): React.JSX.Element => {
  const { returnParams } = props;
  const {
    accountInfoStore: { showPasskey },
  } = useStores();

  const getEmailModals = () => {
    return (
      <>
        <AddEmailModal />
        <ChangePasswordModal />
        <MergeLoginModal />
        <EmailMergeConfirmModal />
        <ForgotPasswordModal />
      </>
    );
  };

  return (
    <>
      <Accordion type="card" size="large">
        {showPasskey && <PasskeyAccordionItem />}
        <EmailAccordionItem returnParams={returnParams} />
      </Accordion>
      {getEmailModals()}
    </>
  );
};

export default AccountLoginMethods;
